import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-two-factor-prompt',
    templateUrl: './two-factor-prompt.component.html',
    styleUrls: ['./two-factor-prompt.component.scss'],
    standalone: false
})
export class TwoFactorPromptComponent {
  title: string;
  message: string;
  code: string = '';
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<TwoFactorPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  /** Filters input to digits only and caps at 6 characters. */
  onCodeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.code = input.value.replace(/\D/g, '').slice(0, 6);
    input.value = this.code;
    this.errorMessage = '';
  }

  /** Returns true when exactly 6 digits have been entered. */
  get isValid(): boolean {
    return /^\d{6}$/.test(this.code);
  }

  onVerify(): void {
    if (!this.isValid) {
      this.errorMessage = 'Please enter a valid 6-digit code.';
      return;
    }
    this.dialogRef.close(this.code);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
